import type { FrozenResourceType } from "~/components/DeploymentFreezes/FrozenIcon";
import FrozenIcon from "~/components/DeploymentFreezes/FrozenIcon";
import styles from "./style.module.less";
export default (props: {
    for: FrozenResourceType;
}) => (<span className={styles.dashboardIcon}>
        <FrozenIcon for={props.for}/>
    </span>);
